import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const CATEGORIES = [
  'Movies',
  'Web Series',
  'Theories',
  'Recommendations',
  'General Discussion'
];

export default function CreateThread() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('General Discussion');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || submitting) return;

    setSubmitting(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/community/threads`, {
        title: title.trim(),
        content: content.trim(),
        category
      }, { withCredentials: true });
      navigate(`/community/${res.data.thread_id}`);
    } catch (error) {
      console.error('Error creating thread:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen pt-20" data-testid="create-thread-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <button onClick={() => navigate('/community')} className="flex items-center space-x-2 text-muted-foreground hover:text-foreground transition-colors mb-8"><ArrowLeft className="w-5 h-5" /><span>Back to Community</span></button>

        <h1 className="font-heading text-4xl font-bold tracking-tight mb-8">Create New Thread</h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium mb-2">Category</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full px-4 py-3 bg-card border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary" data-testid="category-select">
              {CATEGORIES.map(cat => <option key={cat} value={cat}>{cat}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Title *</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="What's on your mind?" className="w-full px-4 py-3 bg-card border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary" data-testid="title-input" required />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Content (optional)</label>
            <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Share more details..." rows={8} className="w-full px-4 py-3 bg-card border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary resize-none" data-testid="content-textarea" />
          </div>

          <div className="flex space-x-4">
            <button type="submit" disabled={submitting || !title.trim()} className="flex-1 bg-primary text-primary-foreground px-6 py-3 rounded-full font-semibold btn-glow hover:opacity-90 transition-all disabled:opacity-50" data-testid="submit-thread-button">Create Thread</button>
            <button type="button" onClick={() => navigate('/community')} className="px-6 py-3 bg-card border border-border rounded-full font-semibold hover:bg-accent transition-colors">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}